/* eslint-disable */
import React, { useContext, useState } from 'react';
import { BasicIconButton, Button, CustomPopover, Modal } from 'components';
import { addJobes } from 'redux/features/PostJobSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { JobPostsStyle, JobLinkPopover } from './JobPosts.style';
import { t } from 'i18next';
import BasicChips from 'components/Chip.js';
import { Divider } from '@mui/material';
import Template1 from 'pages/createform/Template1';
import Template2 from 'pages/createform/Template2';
import CustomTemplate from 'pages/createform/CustomTemplate';
import { Notification } from 'components/CustomNotification';
import { companySizeList } from 'assert/OptionList';
import ShareModal from 'pages/home/ShareModal';
import { PostedUserDetails } from 'pages/business/Buisness.style';
import { Capacitor } from '@capacitor/core';
import { Share as ShareCapacitor } from '@capacitor/share';
import moment from 'moment';
import { isDateExceeding60Days } from 'utils/helper';
import { AuthContext } from 'router/AuthProvider';
import LoginNotification from 'pages/auth/LoginNotification';
import clsx from 'clsx';
import BasicPopover from 'components/Popover';
import { Browser } from '@capacitor/browser';

import { ReactComponent as Location } from 'assert/images/Jobs/location.svg';
import { ReactComponent as BriefCase } from 'assert/images/Jobs/briefCase.svg';
import { ReactComponent as SampleCompany } from 'assert/images/Jobs/sampleCompany.svg';
import { ReactComponent as WorkLocation } from 'assert/images/Jobs/workLocation.svg';
import { ReactComponent as Money } from 'assert/images/Jobs/money.svg';
import { ReactComponent as Copy } from 'assert/images/Jobs/copy.svg';
import { ReactComponent as Tick } from 'assert/images/Jobs/tick.svg';
import { ReactComponent as OpenInNew } from 'assert/images/Common/openInNew.svg';
import { ReactComponent as ShareIcon } from 'assert/images/Home/share.svg';
import { ReactComponent as SampleProfile } from 'assert/images/Common/profileImg.svg';
import { ReactComponent as ExpandMoreIcon } from 'assert/images/Common/arrowDown.svg';
import { ReactComponent as More } from 'assert/images/Home/moreHorizantal.svg';
import { ReactComponent as Report } from 'assert/images/More/report.svg';
import { ShareBaseUrl } from 'environment';
import { PostPopOver } from 'pages/home/Home.style';
import ReportModal from 'components/ReportModal';

export default function Preview({
  onChangeTab,
  postid,
  state,
  isApply,
  disableAction,
  fieldReset,
  jobPostPreview,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLoggedIn } = useContext(AuthContext);
  const isNative = Capacitor.isNativePlatform();

  const { jobList, workTypeList, countryList } = useSelector(
    (state) => state?.DropdownReducer
  );
  const { getProfile } = useSelector((state) => state?.ProfileSlice);
  const userId = getProfile.userId;

  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [displayConfirmPopup, setDisplayConfirmPopup] = useState(false);
  const [initialState, setInitialState] = useState(null);
  const [stateChangedValue, setStateChangedValue] = useState(null);
  const [shareOpen, setShareOpen] = useState(false);
  const [tempAppliedList, setTempAppliedList] = useState([]);
  const [isLoginNotificationOpen, setIsLoginNotificationOpen] = useState(false);
  const [isLinkPopoverOpen, setIsLinkPopoverOpen] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [openPopover, setOpenPopover] = useState(false);
  const [isReportModalOpen, setIsReportModalOpen] = useState("");

  const publishPost = () => {
    setLoading(true);
    state?.location.forEach((ele) => {
      countryList.find((loc) => {
        if (ele.country === loc.label) {
          ele.country = loc.value;
        }
      });
    });
    dispatch(addJobes(state, postid, userId))
      .then((res) => {
        setLoading(false);
        fieldReset();
        Notification('success', res?.data?.message);
        navigate(`/jobs-detail/${res?.data?.data?.jobPostId}`);
      })
      .catch((err) => {
        setLoading(false);
        Notification('error', err.response?.data?.message);
      });
  };

  const handleCloseModal = (changedValue) => {
    if (initialState !== changedValue) {
      setDisplayConfirmPopup(true);
    } else {
      setModalOpen(false);
    }
  };

  const hanldeRenderPreTemplate = (val) => {
    switch (val) {
      case 'Template 1':
        return (
          <Template1
            closeModal={handleCloseModal}
            handleSuccessClose={(id) => {
              setModalOpen(false);
              setTempAppliedList([...tempAppliedList, id]);
            }}
            apply={isApply}
            jobState={state}
            setInitialState={setInitialState}
            setStateChangedValue={setStateChangedValue}
          />
        );
      case 'Template 2':
        return (
          <Template2
            closeModal={handleCloseModal}
            handleSuccessClose={(id) => {
              setModalOpen(false);
              setTempAppliedList([...tempAppliedList, id]);
            }}
            apply={isApply}
            jobState={state}
            setInitialState={setInitialState}
            setStateChangedValue={setStateChangedValue}
          />
        );
      case 'Custom Template':
        return (
          <CustomTemplate
            closeModal={handleCloseModal}
            handleSuccessClose={(id) => {
              setModalOpen(false);
              setTempAppliedList([...tempAppliedList, id]);
            }}
            apply={isApply}
            jobState={state}
            setInitialState={setInitialState}
            setStateChangedValue={setStateChangedValue}
          />
        );
    }
  };

  const handleCopy = () => {
    if (state?.link) {
      navigator.clipboard.writeText(state.link);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    }
  };

  const applyButton = () => {
    return state?.userId == userId ? null : (
      <>
        <Button
          className={clsx(state?.link && 'job-link-button')}
          label={state?.link ? t('Job.Apply') : t('Job.QuickApply')}
          endIcon={state?.link && <OpenInNew />}
          onClick={async () => {
            if (state?.preTemplate) {
              isLoggedIn
                ? jobPostPreview
                  ? {}
                  : setModalOpen(true)
                : setIsLoginNotificationOpen(true);
            } else if (
              /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
                state?.link
              )
            ) {
              const email = encodeURIComponent('ashleyhorton@anderson.org');
              const subject = encodeURIComponent(
                `Application for ${state?.jobTitle}`
              );
              const body = encodeURIComponent(
                'Dear Hiring Manager / Hiring Team,'
              );
              window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
            } else if (Capacitor.isNativePlatform()) {
              await Browser.open({ url: state?.link });
            } else {
              window.open(state?.link, '_blank');
            }
          }}
        />

        {state?.link && (
          <BasicPopover
            handlePopoverClick={() => setIsLinkPopoverOpen(true)}
            isOpen={isLinkPopoverOpen}
            action={
              <Button
                className="job-link-down-arrow"
                label={<ExpandMoreIcon />}
              />
            }
            content={
              <JobLinkPopover>
                <div className="job-link-item">
                  <div className="job-link-path" title={state?.link}>
                    {state?.link}
                  </div>
                  <div className="job-link-icon-item">
                    {!isCopied ? (
                      <Copy onClick={handleCopy} className="job-link-icon" />
                    ) : (
                      <Tick />
                    )}
                  </div>
                </div>
              </JobLinkPopover>
            }
          />
        )}
      </>
    );
  };

  const jobLocation = state?.location
    ? typeof state?.location === 'string'
      ? JSON.parse(state?.location)
      : state?.location
    : [];
  const workIds = Array.isArray(state?.workTypeIds)
    ? state?.workTypeIds
    : state?.workTypeIds
    ? state?.workTypeIds?.split(',')
    : [];
  const jobIds = Array.isArray(state?.jobTypeIds)
    ? state?.jobTypeIds
    : state?.jobTypeIds
    ? state?.jobTypeIds?.split(',')
    : [];

  const renderApply = () => {
    return (
      <div className="job-apply-button">
        {isDateExceeding60Days(state?.created_At) ? (
          <BasicChips
            className="job-applied-error"
            label={t('profile.ExpiredJob')}
            color="error"
            variant="outlined"
            size="small"
          />
        ) : (
          <>
            {state?.jobSubmitted ||
            tempAppliedList.includes(state?.jobPostId) ? (
              <BasicChips
                className="job-applied"
                label={t('profile.Applied')}
                // color="success"
              />
            ) : (
              applyButton()
            )}
          </>
        )}
      </div>
    );
  };

  const PostDropdown = () => {
    return (
      <PostPopOver>
        <div
          onClick={() => {
            if (isNative) {
              ShareCapacitor.share({
                title: 'New Jobs on Wafynet',
                text: `${state?.jobTitle}\n`,
                url: `${ShareBaseUrl}/jobs-detail/${state?.jobPostId}`,
                dialogTitle: 'Share with...',
              });
            } else {
              setShareOpen(true);
            }
          }}
          className='job-share'
        >
          <ShareIcon /> {t('Job.Share')}
        </div>
        {isLoggedIn && userId !== state?.jobPostedUserInfo?.userId && (
          <div
            onClick={() => {
              setIsReportModalOpen(state?.jobPostId);
            }}
            className="deletelist-icon"
          >
            <Report />
            <div>{t('BusinessPlace.Report')}</div>
          </div>
        )}
      </PostPopOver>
    );
  };

  return (
    <JobPostsStyle>
      <div className="job-short-preview">
        <div className="job-more-btn">
          <CustomPopover
            isOpen={openPopover}
            handlePopoverClick={() => {
              if (isLoggedIn) {
                setOpenPopover(true);
              }
            }}
            disableRefClick={!isLoggedIn}
            action={<BasicIconButton icon={<More />} size="small" />}
            content={PostDropdown()}
          />
        </div>
        <div className="job-updated-time">
          {moment(state?.updated_At).fromNow(true)}
        </div>
        <div className="job-preview-image">
          {state?.companyLogo ? (
            <img
              alt="company-logo"
              className="job-list-company-logo"
              src={state?.companyLogo}
            />
          ) : (
            <SampleCompany className="job-list-sample-company-logo" />
          )}
          <div className="job-preview-header">
            <h2>{state?.jobTitle}</h2>
            <div className="job-types">{state?.companyName}</div>
          </div>
        </div>
        <div className="job-types job-work-location">
          <BriefCase className="job-brief-icon" />
          <div>
            {jobIds?.map((itemId, index) => {
              return (
                <BasicChips
                  key={index}
                  variant="outlined"
                  size="small"
                  label={
                    jobList.find((jobItem) => jobItem.value == itemId)?.label
                  }
                />
              );
            })}
          </div>
        </div>
        <div className="job-types">
          <WorkLocation />
          {workIds?.map((itemId, index) => {
            return (
              <BasicChips
                key={index}
                variant="outlined"
                size="small"
                label={
                  workTypeList.find(
                    (workTypeItem) => workTypeItem.value == itemId
                  )?.label
                }
              />
            );
          })}
        </div>
        {jobLocation?.length > 0 ? (
          <div className="job-types job-work-location">
            <Location />
            <div>
              {jobLocation?.map((item, index) => {
                const ctr = countryList.find(
                  (ele) =>
                    ele.value === item.country || ele.label === item.country
                )?.label;
                return (
                  <BasicChips
                    variant="outlined"
                    size="small"
                    key={'preview_location_' + index}
                    label={item?.city ? item?.city + ', ' + ctr : ctr}
                  />
                );
              })}
            </div>
          </div>
        ) : null}
        {state?.salary && (
          <div className="job-types">
            <Money />
            <div className="currency">{state?.salary}</div>
          </div>
        )}
        {state?.yearOfExperience ? (
          <div className="job-types">
            <div className="currency">
              Experience: {state?.yearOfExperience} Years
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
      {renderApply()}
      {state?.jobPostedUserInfo && state.jobPostedUserInfo.headline && (
        <PostedUserDetails className="posted-user-details">
          <div className="posted-user-title">{t('Job.Postedby')}</div>
          <div className="posted-user-container">
            <div className="posted-user-img">
              {state.jobPostedUserInfo.profileImage ? (
                <img
                  className="user-profile-img"
                  src={state.jobPostedUserInfo.profileImage}
                />
              ) : (
                <SampleProfile className="user-profile-img" />
              )}
            </div>
            <div className="posted-username-details">
              <div className="posted-name-container">
                <span
                  className="user-action"
                  onClick={() =>
                    navigate('/profile/' + state.jobPostedUserInfo.userName)
                  }
                >
                  {state.jobPostedUserInfo.displayName}
                </span>
                <span className="posted-username">
                  {' '}
                  · {` @${state.jobPostedUserInfo.userName}`}
                </span>
              </div>
              <div className="posted-headline">
                {state.jobPostedUserInfo.headline}
              </div>
            </div>
          </div>
        </PostedUserDetails>
      )}
      <Divider />
      <div className="sub-title">{t('profile.AboutJob')}</div>
      <div
        className="description-section"
        dangerouslySetInnerHTML={{ __html: state?.jobDescription }}
      />
      {renderApply()}
      <Divider />
      <div className="company-preview-container">
        <div className="sub-title">{t('Job.AboutTheCompany')}</div>
        <div className="comapny-short-preview">
          {state?.companyLogo?.length ? (
            <img
              alt="company-logo"
              className="job-company-logo"
              src={
                state?.companyLogo?.[0]?.preview
                  ? URL?.createObjectURL(state?.companyLogo[0])
                  : state?.companyLogo
              }
            />
          ) : (
            <SampleCompany className="job-sample-company-logo" />
          )}
          <div className="company-header">
            <div className="company-title">{state?.companyName}</div>
            <div className="company-size">
              {
                companySizeList.find((li) => li.id === state?.companySize)
                  ?.label
              }
            </div>
            <a
              target="_blank"
              rel="noreferrer"
              href={
                state?.companyWebsite?.startsWith('https://')
                  ? state?.companyWebsite
                  : 'https://' + state?.companyWebsite
              }
              className="company-link"
            >
              {state?.companyWebsite?.startsWith('https://')
                ? state?.companyWebsite
                : 'https://' + state?.companyWebsite}{' '}
              <OpenInNew />
            </a>
          </div>
        </div>
        {state?.companyDescription && (
          <div
            className="description-section"
            dangerouslySetInnerHTML={{
              __html: state?.companyDescription,
            }}
          />
        )}
      </div>
      {!isApply && !disableAction && (
        <div className="job-publish-button">
          <Button
            variant="outlined"
            label={t('Job.BackToEdit')}
            onClick={() => onChangeTab(0)}
          />
          <Button
            label={t('Job.Publish')}
            onClick={publishPost}
            loading={loading}
            loadingIndicator="Loading…"
          />
        </div>
      )}
      {state?.preTemplate && (
        <Modal
          content={hanldeRenderPreTemplate(state?.preTemplate)}
          openModal={modalOpen}
          modelTitle={state?.preTemplate}
          modalchanges={'job-template'}
          handleCancelModal={() => {
            if (
              stateChangedValue !== null &&
              initialState !== stateChangedValue
            ) {
              setDisplayConfirmPopup(true);
            } else {
              setModalOpen(false);
            }
          }}
        />
      )}
      <Modal
        removeHeader
        modalchanges="headerProfile"
        handleCancelModal={() => setDisplayConfirmPopup(false)}
        openModal={displayConfirmPopup}
        content={
          <div className="confirmModal">
            <div className="title">{t('Job.CloseDialog')}</div>
            <div className="sub-title">{t('Job.ChangesNotSave')}</div>
            <div>
              <Button
                label={t('Job.Cancel')}
                variant="text"
                onClick={() => setDisplayConfirmPopup(false)}
              />
              <Button
                label={t('Job.Discard')}
                color="error"
                onClick={() => {
                  setInitialState(null);
                  setStateChangedValue(null);
                  setModalOpen(false);
                  setDisplayConfirmPopup(false);
                }}
              />
            </div>
          </div>
        }
      />
      <Modal
        handleCancelModal={() => setShareOpen(false)}
        openModal={shareOpen}
        modalchanges={'share-modal'}
        modelTitle={t('HomePage.Share')}
        width={500}
        closable
        content={<ShareModal path={`/jobs-detail/${state?.jobPostId}`} />}
      />
      <LoginNotification
        isLoginNotificationOpen={isLoginNotificationOpen}
        handleUpdateModal={() => {
          setIsLoginNotificationOpen(false);
        }}
      />
      <ReportModal
        resourceType={'job'}
        resourceId={isReportModalOpen}
        handleCloseReportModal={(data) => {
          setIsReportModalOpen("");
          if (data?.closePopover) {
            setOpenPopover(false);
          }
        }}
      />
    </JobPostsStyle>
  );
}
